import { defineMessages } from 'react-intl';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { LIFECYCLE } from '@sorare/core/src/hooks/useLifecycle';

import cover from 'components/market/assets/auctions.webp';
import { useCurrentMarketplaceUserContext } from 'contexts/currentMarketplaceUser';

import { OneTimeOnboardingDialog as OnboardingDialog } from '..';

const messages = defineMessages({
  title: {
    id: 'NewsSigningsOnboardingDialog.title',
    defaultMessage: 'New card auctions',
  },
  description: {
    id: 'NewsSigningsOnboardingDialog.description',
    defaultMessage:
      'Bid on cards in auctions to take a chance at becoming the first owner of those new Sorare cards',
  },
});

export const NewsSignings = () => {
  const { sport } = useSportContext();
  const { wonTokenAuctions } = useCurrentMarketplaceUserContext();

  if (sport !== Sport.FOOTBALL) return null;

  return (
    <OnboardingDialog
      title={messages.title}
      description={messages.description}
      img={cover}
      lifecycleKey={LIFECYCLE.sawMarketplaceOnboarding}
      show={wonTokenAuctions?.hasAny === false}
    />
  );
};
